import React, { createContext, useState } from 'react';

type VisualizationProps = {
  visualizationState: string;
  setVisualizationState: React.Dispatch<React.SetStateAction<string>>;
  fetchUserTypeState: boolean;
  setFetchUserTypeState: React.Dispatch<React.SetStateAction<boolean>>;
};

const initialValues = {
  visualizationState: 'card',
  setVisualizationState: () => {
    ('');
  },
  fetchUserTypeState: true,
  setFetchUserTypeState: () => {
    //
  }
};

const VisualizationContext = createContext<VisualizationProps>(initialValues);

const VisualizationContextProvider: React.FC = ({ children }) => {
  const [visualizationState, setVisualizationState] = useState(
    initialValues.visualizationState
  );

  const [fetchUserTypeState, setFetchUserTypeState] = useState(
    initialValues.fetchUserTypeState
  );

  return (
    <VisualizationContext.Provider
      value={{
        visualizationState,
        setVisualizationState,
        fetchUserTypeState,
        setFetchUserTypeState
      }}
    >
      {children}
    </VisualizationContext.Provider>
  );
};
export { VisualizationContextProvider };
export default VisualizationContext;
